/**
 * Precarga la primera imagen de cada color.
 *
 * Al pasar el cursor por un swatch —o al enfocarlo con el teclado— se pide la
 * primera imagen de ese color, de modo que al hacer clic el navegador ya la
 * tiene. Es solo percepción de velocidad: si algo falla, no pasa nada, la
 * galería se carga como siempre.
 *
 * El mapa color → url lo escribe snippets/mr-gallery-preload-map.liquid.
 */
class MrGalleryPreload extends HTMLElement {
  /** @type {Record<string, string>} */
  #map = {};
  #preloaded = new Set();
  #controller = new AbortController();

  connectedCallback() {
    const source = this.querySelector('script[type="application/json"]');
    if (!source?.textContent) return;

    try {
      this.#map = JSON.parse(source.textContent);
    } catch {
      return;
    }

    const section = this.closest('.shopify-section, dialog');
    if (!section) return;

    const { signal } = this.#controller;
    section.addEventListener('pointerenter', this.#handlePointer, { capture: true, signal });
    section.addEventListener('focusin', this.#handlePointer, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /** @param {Event} event */
  #handlePointer = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const label = target.closest('.variant-option__button-label--has-swatch');
    const input = label?.querySelector('input[type="radio"]');
    if (!(input instanceof HTMLInputElement)) return;

    this.#preload(input.value);
  };

  /** @param {string} value */
  #preload(value) {
    const url = this.#map[value];
    if (!url || this.#preloaded.has(url)) return;

    this.#preloaded.add(url);
    const image = new Image();
    image.decoding = 'async';
    image.src = url;
  }
}

if (!customElements.get('mr-gallery-preload')) {
  customElements.define('mr-gallery-preload', MrGalleryPreload);
}
